import React, { useState } from 'react'

import { Form, DatePicker } from 'antd'
import { Rule } from 'antd/lib/form'
import moment from 'moment'
import { CSSProperties } from 'styled-components'

interface DateRangeProps {
  name: string
  label: string
  showTime: boolean
  maxDays?: number
  rules?: Rule[]
}

const DateRange = ({
  name,
  label,
  showTime,
  maxDays,
  rules,
}: DateRangeProps) => {
  const [dates, setDates] = useState<any>([])
  const [hackValue, setHackValue] = useState<any>()
  const [value, setValue] = useState<any>()

  const today: Date = new Date()

  function disabledDate(current: moment.Moment) {
    return (
      maxDays &&
      dates?.length > 0 &&
      ((dates[0] && current.diff(dates[0], 'days') > maxDays) ||
        (dates[1] && dates[1].diff(current, 'days') > maxDays))
    )
  }

  function onOpenChange(open: boolean) {
    if (open) {
      setHackValue([])
      setDates([])
    } else {
      setHackValue(undefined)
    }
  }

  return (
    <Form.Item name={name} label={label} rules={rules}>
      <DatePicker.RangePicker
        showTime={
          showTime
            ? {
                format: 'HH:mm',
                defaultValue: [
                  moment('00:00:00', 'HH:mm:ss'),
                  moment('23:59:59', 'HH:mm:ss'),
                ],
              }
            : false
        }
        format={showTime ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY'}
        defaultValue={[
          moment([
            today.getFullYear(),
            today.getMonth(),
            today.getDate(),
            0,
            0,
            0,
          ]),
          moment([
            today.getFullYear(),
            today.getMonth(),
            today.getDate(),
            23,
            59,
            59,
          ]),
        ]}
        value={hackValue || value}
        disabledDate={disabledDate}
        onCalendarChange={(val) => setDates(val)}
        onChange={(val) => setValue(val)}
        onOpenChange={onOpenChange}
        style={{ width: '100%' }}
      />
    </Form.Item>
  )
}

export default DateRange
